import {
  ContentType,
  isIdea,
  isProductUpdate
} from '@insided/shared/utils/contentType'

export interface UnreadByTeamCellProps {
  contentType: ContentType
  moderationStatus: {
    repliedSinceLastModeration: number
    isModerated: boolean
  }
}

const UnreadByTeamCell = ({
  contentType,
  moderationStatus: { repliedSinceLastModeration, isModerated }
}: UnreadByTeamCellProps) => {
  if (isIdea(contentType) || isProductUpdate(contentType)) {
    return <div className='overview__unread-by-team--not-supported'>(Not supported)</div>
  }

  if (!isModerated) {
    return (
      <div className='overview__unread-by-team'>
        <div>
          New topic{repliedSinceLastModeration > 0 && ` (+${repliedSinceLastModeration})`}
        </div>
      </div>
    )
  }

  if (isModerated && repliedSinceLastModeration > 0) {
    return (
      <div className='overview__unread-by-team'>
        <div>+ {repliedSinceLastModeration} Replies</div>
      </div>
    )
  }

  return <div className='overview__unread-by-team' />
}

export default UnreadByTeamCell
